// extracted by mini-css-extract-plugin
export var gif = "_jb-0";